import { io, Socket } from 'socket.io-client';
import { useAuthStore } from '../store/authStore';

const SOCKET_URL = import.meta.env.VITE_SOCKET_URL || window.location.origin;

let socket: Socket | null = null;

export const socketService = {
  connect(): Socket {
    // Return the existing instance whether connected or mid-reconnection.
    // Creating a new socket while the old one is reconnecting causes duplicate
    // instances with split listeners.
    if (socket) return socket;

    socket = io(SOCKET_URL, {
      // A function (not a static object) so socket.io re-invokes it on every
      // automatic reconnection attempt too, not just the first connect — a
      // static token here would go stale after the access token refreshes
      // and silently break auth on the next reconnect.
      auth: (cb) => cb({ token: useAuthStore.getState().accessToken }),
      transports: ['websocket', 'polling'],
      // No reconnectionAttempts cap — a long-lived tab with a job in flight
      // must keep retrying indefinitely (socket.io-client's default), or a
      // transient network blip permanently silences future run_completed
      // events for the rest of the session.
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
    });

    socket.on('connect_error', (err) => {
      console.warn('[socket] Connection error:', err.message);
    });

    return socket;
  },

  disconnect(): void {
    if (socket) {
      socket.disconnect();
      socket = null;
    }
  },

  getSocket(): Socket | null {
    return socket;
  },
};
